import './MGModalitySubscription.css'
import MGModalityCardSubscription from './MGModalityCardSubscription';


export default function MGModalitySubscriptionList({ subscriptionList, publicURL }) {

    return (
        <div className='MGModalitySubscriptionList-card-list'>
            {subscriptionList.map((item) => (
                <MGModalityCardSubscription
                    publicURL={publicURL}
                    title={item.title}
                    imgUrl={item.images?.[0]?.url}
                    bullets={item.bullets} />
            ))}
        </div>
    );
}